import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["audio"]

  connect() {
    // Create an audio element and set its source
  }

  play() {
    // Play the audio
    this.audioTarget.play().catch(error => {
      console.error("Error playing audio:", error);
    });
  }

}